export const requestTags = {
  userRequestTags: { getUsers: "userCollection" },
  scriptTranslationsRequestTags: { getLocalization: "getLocalization" },
  scriptsRequestTags: {
    getScriptById: (id: number) => `script-${id}`,
    getLinkedMap: (id: number) => `script-linkedMap-${id}`,
    countScriptSteps: (id: number) => `countScriptSteps-${id}`,
  },
  projectsRequestTags: {
    getProjectById: (id: number) => `project-${id}`,
  },
  schedulersRequestTags: {
    getSchedulers: "getSchedulers",
  },
  globalSettingsRequestTags: {
    getGlobalSettings: "getGlobalSettings",
    getScreenshotsAutoCleanup: "getScreenshotsAutoCleanup",
  },
};
